/* eslint-disable max-len */
import styled from 'styled-components';
import TransferIconDark from '../../assets/images/transfer-out-icon.svg';
import TransferIconLight from '../../assets/images/transfer-out-icon-light.svg';

const TransferOutIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${TransferIconDark}") no-repeat left center`
      : `url("${TransferIconLight}") no-repeat left center`};
  background-size: 27px 16px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 16px;
  width: 27px;
`;

export default TransferOutIcon;
